<div [ngClass]="{ 'profile-wrapper': !isMobile, 'profile-mobile-wrapper': isMobile }">

  <h2 class="title" *ngIf="!isMobile">
    {{ 'profile.title' | translate }}
  </h2>

  <!-- Mobile breadcrumb -->
  <div class="mobile-breadcrumb" *ngIf="isMobile">
    <button class="back-btn" (click)="goBacktoHome()">
      <i class="bi bi-chevron-left" *ngIf="userLang=='en'"></i>
      <i class="bi bi-chevron-right" *ngIf="userLang=='ar'"></i>
    </button>
    <div class="breadcrumb-text">
      <span class="breadcrumb-home" (click)="goBackToProfile()">
        {{ 'profile.title' | translate }}
      </span>
    </div>
  </div>

  <div class="page-head" *ngIf="!isPersonalDataPage() && !isChangePasswordPage() && isMobile">
    <div class="breadcrumb-text">
      <span class="breadcrumb-home" (click)="goBackToProfile()">
        {{ 'profile.title' | translate }}
      </span>
      <i class="bi bi-slash-lg"></i>
      <span class="breadcrumb-current">{{ getCurrentPageTitle() | translate }}</span>
    </div>
  </div>

  <div class="profile-card">
    <div class="card-body">

      <!-- Sidebar -->
      <div class="sidebar" *ngIf="!isMobile">
        <ul>
          <li routerLink="profile-overview" routerLinkActive="active">
            <i class="bi bi-person"></i> {{ 'Profile overview' | translate }}
          </li>
          <li routerLink="personal-data" routerLinkActive="active">
            <i class="bi bi-person"></i> {{ 'profile.personalData' | translate }}
          </li>
          <!-- <li routerLink="auto-apply-jobs" routerLinkActive="active">
            <i class="bi bi-briefcase"></i> {{ 'profile.autoApplyJobs' | translate }}
          </li> -->
          <li routerLink="generated-cv" routerLinkActive="active">
            <i class="bi bi-file-earmark-text"></i> {{ 'profile.generatedCV' | translate }}
          </li>
          <li routerLink="evaluated-cvs" routerLinkActive="active">
            <i class="bi bi-chat-left-text"></i> {{ 'profile.evaluatedCVs' | translate }}
          </li>
          <li routerLink="generated-cover-letters" routerLinkActive="active">
            <i class="bi bi-file-earmark-text"></i> {{ 'profile.generatedCoverLetters' | translate }}
          </li>
          <li routerLink="evaluated-linkdin-profiles" routerLinkActive="active">
            <i class="bi bi-linkedin"></i> {{ 'profile.evaluatedProfiles' | translate }}
          </li>
          <li routerLink="enhanced-linkedin-profiles" routerLinkActive="active">
            <i class="bi bi-linkedin"></i> {{ 'linkedin_optimization' | translate }}
          </li>
          <li routerLink="interview-training" routerLinkActive="active">
            <i class="bi bi-mic"></i> {{ 'profile.interviewTraining' | translate }}
          </li>
          <li routerLink="applied-jobs" routerLinkActive="active">
            <i class="bi bi-briefcase"></i>{{ 'profile.appliedJobs' | translate }}
          </li>
          <li routerLink="change-password" routerLinkActive="active">
            <i class="bi bi-lock"></i> {{ 'profile.changePassword' | translate }}
          </li>
        </ul>

        <div class="bottom mt-5">
          <a (click)="openLogoutModal()" class="logut">
            <span class="ms-2">{{ 'profile.logout' | translate }}</span>
          </a>

          <a (click)="openDeleteModal()" class="danger">
            <span class="ms-2">{{ 'profile.deleteAccount' | translate }}</span>
          </a>
        </div>
      </div>

      <!-- Mobile tabs -->
      <div class="mobile-tabs" *ngIf="isPersonalDataPage() && isMobile">
        <button class="tab-button" [class.active]="activeTab === 'personal'" (click)="setActiveTab('personal')"
          routerLink="personal-data">
          <i class="bi bi-person"></i>
          {{ 'profile.personalData' | translate }}
        </button>

        <button class="tab-button" [class.active]="activeTab === 'services'" (click)="setActiveTab('services')">
          <i class="bi bi-grid"></i>
          {{ 'profile.services' | translate }}
        </button>
      </div>

      <!-- Services Dropdown -->
      <div class="services-dropdown" *ngIf="isMobile && showServicesDropdown && isPersonalDataPage()">
        <ul>
          <li routerLink="auto-apply-jobs">{{ 'profile.autoApplyJobs' | translate }}</li>
          <li routerLink="generated-cv">{{ 'profile.generatedCV' | translate }}</li>

          <li routerLink="evaluated-cvs">{{ 'profile.evaluatedCVs' | translate }}</li>
          <li routerLink="generated-cover-letters">{{ 'profile.generatedCoverLetters' | translate }}</li>
          <li routerLink="applied-jobs" routerLinkActive="active">
            {{ 'profile.appliedJobs' | translate }}
          </li>
          <li routerLink="evaluated-linkdin-profiles">{{ 'profile.evaluatedProfiles' | translate }}</li>
          <li routerLink="enhanced-linkedin-profiles" routerLinkActive="active">
            <i class="bi bi-linkedin"></i> {{ 'linkedin_optimization' | translate }}
          </li>
          <li routerLink="interview-training">{{ 'profile.interviewTraining' | translate }}</li>
          <li routerLink="change-password">{{ 'profile.changePassword' | translate }}</li>
        </ul>
        <div class="bottom mt-5">
          <a (click)="openLogoutModal()" class="logut">
            <span class="ms-2">{{ 'profile.logout' | translate }}</span>
          </a>

          <a (click)="openDeleteModal()" class="danger">
            <span class="ms-2">{{ 'profile.deleteAccount' | translate }}</span>
          </a>
        </div>
      </div>

      <!-- Logout Modal -->
      <div class="custom-modal" *ngIf="showLogoutModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closeLogoutModal()">×</button>
          <h2>{{ 'profile.logoutConfirmTitle' | translate }}</h2>
          <p>{{ 'profile.logoutConfirmDesc' | translate }}</p>

          <div class="modal-actions">
            <button class="btn-logout" (click)="confirmLogout()">
              {{ 'profile.logout' | translate }}
            </button>
            <button class="btn-cancel" (click)="closeLogoutModal()">
              {{ 'common.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="custom-modal" *ngIf="showLDeleteModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closeDeleteModal()">×</button>

          <h2>{{ 'profile.deleteConfirmTitle' | translate }}</h2>
          <p>{{ 'profile.deleteConfirmDesc' | translate }}</p>

          <div class="modal-actions">
            <button class="btn-logout" (click)="deleteUserAccount()">
              {{ 'profile.deleteAccount' | translate }}
            </button>
            <button class="btn-cancel" (click)="closeDeleteModal()">
              {{ 'common.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <div class="content" *ngIf="!showServicesDropdown">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>